(function () {
  function getHeaderOffset() {
    var root = document.documentElement;
    var live = getComputedStyle(root).getPropertyValue('--header-height-live').trim();
    var base = getComputedStyle(root).getPropertyValue('--header-height').trim();
    var value = parseFloat(live) || parseFloat(base) || 0;
    return Number.isFinite(value) ? value : 0;
  }

  function bindGuide(root) {
    if (!root || root.dataset.guideBound === 'true') return;
    root.dataset.guideBound = 'true';

    var tocPin = root.querySelector('[data-guide-toc-pin]');
    var tocWrap = root.querySelector('[data-guide-toc-wrap]');
    var tocList = root.querySelector('[data-guide-toc-list]');
    var indicator = root.querySelector('[data-guide-toc-indicator]');
    var tocLinks = Array.from(root.querySelectorAll('[data-guide-toc-link]'));
    var mobileSelect = root.querySelector('[data-guide-toc-select]');
    var headings = Array.from(root.querySelectorAll('[data-guide-heading]'));
    var scrollingFromClick = false;
    var scrollTimer = null;
    var rafId = null;

    function getActiveLink() {
      return tocLinks.find(function (link) {
        return link.classList.contains('is-active');
      });
    }

    function moveIndicator(activeLink) {
      if (!indicator || !tocList || !activeLink) return;

      var item = activeLink.closest('.guide-article__toc-item');
      if (!item) return;

      var barHeight = Math.min(Math.max(item.offsetHeight - 4, 14), 22);
      var top = item.offsetTop + item.offsetHeight / 2 - barHeight / 2;

      indicator.style.height = barHeight + 'px';
      indicator.style.transform = 'translateY(' + top + 'px)';
      indicator.style.opacity = '1';
    }

    function scrollTocIntoView(activeLink) {
      if (!tocWrap || !activeLink) return;

      var wrapRect = tocWrap.getBoundingClientRect();
      var linkRect = activeLink.getBoundingClientRect();

      if (linkRect.top < wrapRect.top + 12) {
        tocWrap.scrollTop += linkRect.top - wrapRect.top - 12;
      } else if (linkRect.bottom > wrapRect.bottom - 12) {
        tocWrap.scrollTop += linkRect.bottom - wrapRect.bottom + 12;
      }
    }

    function setActiveLink(activeLink) {
      if (!activeLink) return;

      tocLinks.forEach(function (link) {
        link.classList.toggle('is-active', link === activeLink);
      });

      if (mobileSelect) {
        mobileSelect.value = activeLink.getAttribute('href') || '';
      }

      scrollTocIntoView(activeLink);
      moveIndicator(activeLink);
    }

    function resetTocPin() {
      if (!tocWrap || !tocPin) return;

      tocWrap.classList.remove('is-pinned', 'is-pinned-bottom');
      tocWrap.style.left = '';
      tocWrap.style.width = '';
      tocPin.style.minHeight = '';
    }

    function updateTocPin() {
      if (!tocWrap || !tocPin || window.innerWidth <= 989) {
        resetTocPin();
        return;
      }

      var pinRect = tocPin.getBoundingClientRect();
      var rootRect = root.getBoundingClientRect();
      var headerTop = getHeaderOffset() + 24;
      var wrapHeight = tocWrap.offsetHeight;
      var pinWidth = pinRect.width;

      tocPin.style.minHeight = wrapHeight + 'px';

      var sectionBottomLimit = rootRect.bottom - wrapHeight - 16;

      if (pinRect.top > headerTop) {
        resetTocPin();
        return;
      }

      if (sectionBottomLimit <= headerTop) {
        tocWrap.classList.remove('is-pinned');
        tocWrap.classList.add('is-pinned-bottom');
        tocWrap.style.left = '';
        tocWrap.style.width = '';
        return;
      }

      tocWrap.classList.remove('is-pinned-bottom');
      tocWrap.classList.add('is-pinned');
      tocWrap.style.left = pinRect.left + 'px';
      tocWrap.style.width = pinWidth + 'px';
    }

    function findActiveHeadingId() {
      if (!headings.length) return null;

      var offset = getHeaderOffset() + 28;
      var activeId = headings[0].id;

      headings.forEach(function (heading) {
        if (heading.getBoundingClientRect().top <= offset) {
          activeId = heading.id;
        }
      });

      return activeId;
    }

    function syncTocFromScroll() {
      if (scrollingFromClick || !tocLinks.length) return;

      var activeId = findActiveHeadingId();
      if (!activeId) return;

      var hash = '#' + activeId;
      var activeLink = tocLinks.find(function (link) {
        return link.getAttribute('href') === hash;
      });

      if (activeLink && !activeLink.classList.contains('is-active')) {
        setActiveLink(activeLink);
      } else if (activeLink) {
        moveIndicator(activeLink);
      }
    }

    function onScrollOrResize() {
      if (rafId) return;
      rafId = window.requestAnimationFrame(function () {
        rafId = null;
        updateTocPin();
        syncTocFromScroll();
      });
    }

    tocLinks.forEach(function (link) {
      link.addEventListener('click', function (event) {
        var id = link.getAttribute('href');
        if (!id || id.charAt(0) !== '#') return;
        var target = root.querySelector(id);
        if (!target) return;

        event.preventDefault();
        scrollingFromClick = true;
        setActiveLink(link);

        var top = target.getBoundingClientRect().top + window.pageYOffset - getHeaderOffset() - 16;
        window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });

        window.clearTimeout(scrollTimer);
        scrollTimer = window.setTimeout(function () {
          scrollingFromClick = false;
          updateTocPin();
          syncTocFromScroll();
        }, 700);
      });
    });

    if (mobileSelect) {
      mobileSelect.addEventListener('change', function () {
        var id = mobileSelect.value;
        if (!id) return;
        var target = root.querySelector(id);
        if (!target) return;

        scrollingFromClick = true;
        var activeLink = tocLinks.find(function (link) {
          return link.getAttribute('href') === id;
        });
        if (activeLink) setActiveLink(activeLink);

        var top = target.getBoundingClientRect().top + window.pageYOffset - getHeaderOffset() - 16;
        window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });

        window.clearTimeout(scrollTimer);
        scrollTimer = window.setTimeout(function () {
          scrollingFromClick = false;
          updateTocPin();
          syncTocFromScroll();
        }, 700);
      });
    }

    root.querySelectorAll('[data-guide-tabs]').forEach(function (tabs) {
      tabs.addEventListener('click', function (event) {
        var btn = event.target.closest('[data-guide-tab]');
        if (!btn || !tabs.contains(btn)) return;
        var key = btn.getAttribute('data-guide-tab');
        tabs.querySelectorAll('[data-guide-tab]').forEach(function (tab) {
          var on = tab.getAttribute('data-guide-tab') === key;
          tab.classList.toggle('is-active', on);
          tab.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        tabs.querySelectorAll('[data-guide-tab-panel]').forEach(function (panel) {
          panel.hidden = panel.getAttribute('data-guide-tab-panel') !== key;
        });
      });
    });

    if (tocWrap && tocLinks.length) {
      window.addEventListener('scroll', onScrollOrResize, { passive: true });
      window.addEventListener('resize', onScrollOrResize);
      tocWrap.addEventListener(
        'scroll',
        function () {
          moveIndicator(getActiveLink());
        },
        { passive: true }
      );

      updateTocPin();
      syncTocFromScroll();
      moveIndicator(getActiveLink() || tocLinks[0]);
    }
  }

  function init() {
    document.querySelectorAll('[data-guide-article]').forEach(bindGuide);
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', function (event) {
    var root =
      event.target.querySelector('[data-guide-article]') ||
      (event.target.matches && event.target.matches('[data-guide-article]') ? event.target : null);
    if (root) bindGuide(root);
  });
})();
